import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class PNLService {
  async fetch(page, data, all = false) {
    const param = all ? "all=true" : `page=${page}`;
    const response = await ajaxService.post(
      `/accounts/profit-loss?${param}`,
      data
    );
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const pnlService = new PNLService();
export default pnlService;
